<template>
   <div>
      <el-popover placement="bottom" width="200" trigger="click" v-model="expanded">
         <div class="language-selection__container">
            <div v-for="locale in locales" :key="locale.locale" class="language-selector__locale" @click="setLocale(locale)">
               <img :src="locale.image" class="language-selector__flag" />
               <span>{{locale.name}}</span>
            </div>
         </div>
         <div class="language-selector__button" slot="reference">
            <div class="language-selector__locale">
               <img :src="selected.image" class="language-selector__flag" />
               <span>{{selected.name}}</span>
            </div>
         </div>
      </el-popover>
   </div>
</template>

<script>
const assets = require.context("@/assets", false);
const locales = [
   {
      id: 'en',
      name: 'English',
      image: assets("./ico_lang_en.png", true),
   },
   {
      id: 'pl',
      name: 'Polski',
      image: assets("./ico_lang_pl.png", true),
   }
]

export default {
   data() {
      return {
         locales: locales,
         selected: null,
         expanded: false
      }
   },
   methods: {
      setLocale(locale) {
         this.selected = locale
         this.$i18n.locale = locale.id
         this.expanded = false
      }
   },
   created() {
      let locale = locales.find(l => {
         return l.id === this.$i18n.locale
      })

      this.selected = locale || locales[0]
   }
}
</script>

<style lang="scss" scoped>
@import "../../sass/var";
@import "~element-ui/packages/theme-chalk/src/display";

$--language-flag-size: 24px;
$--language-flag-margin: 2px;

.language-selection__container {
  margin: 6px - $--popover-padding;

  .language-selector__locale {
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      background: $--color-primary-light-1;
    }

    .language-selector__flag {
      border: 1px solid $--border-color-base;
    }
  }
}

.language-selector__button {
  display: inline-block;
  color: white;
  border-radius: 4px;
  box-shadow: $--box-shadow-light;
  padding: 4px;

  span {
    @media screen and (max-width: $--sm - 1) {
      display: none;
    }
  }
}

.language-selector__locale {
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: 2px;
  padding: 4px;
  span {
    margin: 0 8px;
  }
}

.language-selector__flag {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/landing/LanguageSelector.vue